import { render, staticRenderFns } from "./RealDescription.vue?vue&type=template&id=0e98a52b&scoped=true&"
import script from "./RealDescription.vue?vue&type=script&lang=ts&"
export * from "./RealDescription.vue?vue&type=script&lang=ts&"
import style0 from "./RealDescription.vue?vue&type=style&index=0&id=0e98a52b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e98a52b",
  null
  
)

export default component.exports